// extracted by mini-css-extract-plugin
module.exports = {"disabled":"groupsTable_disabled__3o73F","section_header":"groupsTable_section_header__1tzz5","table_container":"groupsTable_table_container__1PhVP"};